// ============================================
// COMPONENT: ForgotPasswordView
// ============================================
// Archivo: src/components/auth/ForgotPasswordView.jsx

import React, { useState } from 'react';
import { Activity, ArrowLeft } from 'lucide-react';

const ForgotPasswordView = ({ onSubmit, onBack }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      alert('Por favor ingresa tu email');
      return;
    }

    setLoading(true);
    const result = await onSubmit(email);
    setLoading(false);

    if (result.success) {
      setEmail('');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <Activity size={64} className="text-blue-600 mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-gray-900">
            Recuperar Contraseña
          </h1>
          <p className="text-gray-600 mt-2">
            Ingresa tu email para recibir una contraseña temporal
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email
            </label>
            <input
              type="email"
              placeholder="tu@email.cl"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Procesando...' : 'Generar Nueva Contraseña'}
          </button>
        </form>

        <button
          onClick={onBack}
          className="w-full mt-4 text-blue-600 hover:text-blue-700 text-sm font-medium flex items-center justify-center gap-2"
        >
          <ArrowLeft size={16} />
          Volver al Login
        </button>

        <div className="mt-6 p-4 bg-slate-50 rounded-lg text-xs text-slate-600">
          <p className="font-semibold mb-2">💡 Nota:</p>
          <p>
            Se generará una contraseña temporal que deberás cambiar en tu primer inicio de sesión.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordView;
